export default __webpack_public_path__ + "static/media/280.51db5d23.jpg";